import { CartItemType } from "../../../../../services/redux/types/CartLoyaltyV2Types";
import { isLoyaltyOfferLine } from "../../../../../utils/cart/cartItemDisplay";
import { ItemType } from "../../../../../utils/types";

function isExcludedOfferLine(item: CartItemType): boolean {
  return !!item.isOfferItem || isLoyaltyOfferLine(item);
}

export const checkCartCount = (
  itemObj: ItemType,
  items: CartItemType[],
  options: { excludingOffers?: boolean } = {}
) => {
  let ret = 0;
  if (items) {
    items.every(function (item) {
      if (
        item.itemDetails.id === itemObj.id &&
        (!options.excludingOffers || !isExcludedOfferLine(item))
      ) {
        ret = item.count;

        return false;
      }

      return true;
    });
  }

  return ret;
};

// export const checkTotalCartCount = (
//   itemObj: ItemType,
//   cart: TransformOfferType<CartType> | CartOutput,
//   options: { excludingOffers?: boolean } = {}
// ) => {
//   let totalCount = 0;
//   if (cart?.items?.length) {
//     for (const item of cart.items) {
//       if (
//         item.itemDetails.id === itemObj.id &&
//         (!options.excludingOffers || !item.isOfferItem)
//       ) {
//         totalCount += item.count || 0;
//       }
//     }
//   }
//   return totalCount;
// };

export const findCartItemIndex = (
  itemObj: ItemType,
  items: CartItemType[],
  options: { excludingOffers?: boolean } = {}
): number => {
  if (!items?.length) {
    return -1;
  }

  const subItemId = itemObj.subItems?.[0]?.id;

  const index = items.findIndex((cartItem) => {
    const matchesItem =
      cartItem.itemDetails.id === itemObj.id &&
      (!options.excludingOffers || !isExcludedOfferLine(cartItem));

    if (!subItemId) {
      return matchesItem;
    }

    return matchesItem && cartItem.subItemDetails?.id === subItemId;
  });

  return index;
};
